<template>
    <base-box background-color="grey" :border="false" padding="none" clickable @click="handleClick">
        <g-media-object slot="content" vertical-align="center">
            <div slot="left" class="collection-image" :style="`background-image: url(${imageUrl}); background-repeat: no-repeat`"></div>
            <div class="content">
                <g-typography size="h3" text-overflow="ellipsis" font-weight="semibold">
                    <slot name="title">{{ collection.name }}</slot>
                </g-typography>
            </div>
            <div slot="right" class="arrow">
                <g-icon name="angle-right" size="small" />
            </div>
        </g-media-object>
    </base-box>
</template>

<script>
    import {PLACEHOLDER_IMAGE} from '../../../../constants/cdn-assets';

    export default {
        name:  'CollectionListItem',
        props: {
            collection: {
                type: Object,
            },
        },
        computed: {
            imageUrl() {
                return this.collection.image || PLACEHOLDER_IMAGE;
            },
        },
        methods: {
            handleClick(){
                this.$emit('click', this.collection.id);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .collection-image {
        height: 100px;
        width: 100px;
        background-position: center;
        background-size: contain;
    }

    .content {
        margin-left: $g-spacing-5;
    }

    .arrow {
        padding-right: $g-spacing-5;
    }
</style>
